import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import SecondaryMenu from '../../menu/secondaryMenu.component';
import { reportingCurrencyCodeSelector, environmentSuffixSelector } from '../../shared/store/selectors';
import { hideDecimalsSelector, negativeMinusSelector, displayZeroSelector, shadeGridFlagSelector } from '../../userData/store/selectors';
import { IsClientLocked } from '../../shared/clientLocked/IsClientLocked.component';
import { fetchAccounts } from '../../shared/store/actions';
import NavigationPrompt, {
  PENDING_ENTRIES_MESSAGE,
  PENDING_ENTRIES_TITLE,
} from '../../shared/navigationPrompt.component';
import {
  changeBookType,
} from '../aggregationMenu/store/actions';
import {
  selectPeriodFrom,
  selectPeriodTo,
  selectSlGroupType,
  selectSlGroupItem,
  selectCountryTaxType,
  selectBookTypes,
  selectBookType,
  currencyToDisplaySelector,
} from '../aggregationMenu/store/selectors';
import {
  tbeErrorsSelector,
  isLoadingTbeErrorsSelector,
  tbeErrorObjSelector,
} from '../store/selectors';
import AggregationMenu from '../aggregationMenu/aggregationMenu.component';
import { OptionPropTypes } from '../aggregationMenu/propTypes';
import { findDirectTaxEntriesDeltaFroGrouppedReport } from '../shared/directEntries.helpers';
import {
  reportDataIsDefined,
  reportDataChanged,
} from '../shared/report.utils';
import { submitDirectTaxEntries } from '../store/actions';
import GridReport from '../gridReport/gridReport.component';
import PendingSubmissions from '../gridReport/pendingSubmissions.component';
import { ReportDataPropTypes } from '../gridReport/propTypes';
import { ObligationPropTypes } from '../../administration/obligationsPage/propTypes';

import {
  fetchReportDataForViewTaxReservePage,
  exportToExcel,
  exportToCsv,
  updateEditedCellForGroup,
  revertEditedCellsForGroup,
} from './store/actions';
import {
  selectReportData,
  selectIsFetchingTaxReservesReport,
  isExportingTaxReserveReportSelector,
  pendingSubmissionsCountSelector,
  isAllowedToMakeDirectEntriesSelector,
  obligationsSelector,
  periodOrCurrentSelector,
} from './store/selectors';
import {
  REPORT_DATA_KEYS,
} from './constants';
import getColumnDefinitions from './columnDefinitions';

class ViewTaxReservesPage extends PureComponent {
  static propTypes = {
    countryTaxType: PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
    changeBookType: PropTypes.func.isRequired,
    periodFrom: PropTypes.shape({
      name: PropTypes.string.isRequired,
      taxYear: PropTypes.string.isRequired,
    }),
    periodTo: PropTypes.shape({
      name: PropTypes.string.isRequired,
      taxYear: PropTypes.string.isRequired,
    }),
    bookType: PropTypes.string.isRequired,
    bookTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
    reportData: ReportDataPropTypes,
    pendingSubmissionsCount: PropTypes.number.isRequired,
    currencyToDisplay: PropTypes.string,
    fetchReportData: PropTypes.func,
    slGroupType: OptionPropTypes,
    slGroupItem: OptionPropTypes,

    reportingCurrency: PropTypes.string,
    tbeErrorVal: OptionPropTypes,
    isFetchingReportData: PropTypes.bool,
    isExportingReport: PropTypes.bool,

    exportToExcel: PropTypes.func.isRequired,
    exportToCsv: PropTypes.func.isRequired,

    hideDecimals: PropTypes.bool.isRequired,
    shouldDisplayZero: PropTypes.bool.isRequired,
    negativeMinus: PropTypes.bool.isRequired,
    updateEditedCellForGroup: PropTypes.func.isRequired,
    revertEditedCellsForGroup: PropTypes.func.isRequired,
    isAllowedToMakeDirectEntries: PropTypes.bool.isRequired,
    environmentSuffix: PropTypes.string.isRequired,
    isRowShadingEnabled: PropTypes.bool.isRequired,

    submitDirectTaxEntries: PropTypes.func.isRequired,
    fetchAccounts: PropTypes.func.isRequired,
    obligations: PropTypes.arrayOf(ObligationPropTypes),
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  };

  static defaultProps = {
    obligations: [],
  };

  componentDidMount() {
    if (this.reportDataIsDefined(this.props)) {
      this.fetchReportData();
    }

    this.props.fetchAccounts();
  }

  componentDidUpdate(prevProps) {
    if (this.reportDataIsDefined(prevProps) && this.reportDataChanged(prevProps)) {
      this.fetchReportData();
    }
  }

  reportDataIsDefined = () => reportDataIsDefined(REPORT_DATA_KEYS, this.props);
  reportDataChanged = prevProps => reportDataChanged(REPORT_DATA_KEYS, prevProps, this.props);

  fetchReportData = () => {
    const {
      periodFrom,
      periodTo,
      slGroupType,
      slGroupItem,
      countryTaxType,
      bookType,
      fetchReportData,
      reportingCurrency,
      tbeErrorVal,
      period,
    } = this.props;

    fetchReportData({
      periodFrom,
      periodTo,
      slGroupType,
      slGroupItem,
      countryTaxType,
      bookType,
      reportingCurrency,
      tbeErrorVal,
      currentPeriod: period.name,
    });
  };

  buildExportArgs = () => {
    const {
      periodFrom,
      periodTo,
      slGroupType,
      slGroupItem,
      countryTaxType,
      reportingCurrency,
      bookTypes,
      hideDecimals,
      shouldDisplayZero,
      negativeMinus,
      environmentSuffix,
    } = this.props;

    return [
      periodFrom,
      periodTo,
      slGroupType,
      slGroupItem,
      countryTaxType,
      reportingCurrency,
      bookTypes,
      hideDecimals,
      shouldDisplayZero,
      negativeMinus,
      environmentSuffix,
    ];
  };

  exportToExcel = () => {
    this.props.exportToExcel(...this.buildExportArgs());
  };

  exportToCsv = () => {
    this.props.exportToCsv(...this.buildExportArgs());
  };

  submitDirectEntries = () => {
    const {
      slGroupItem,
      periodFrom,
      countryTaxType,
      currencyToDisplay,
      bookType,
      obligations,
      reportData,

      submitDirectTaxEntries,
    } = this.props;
    const { rows } = reportData;

    let isEnabled = true;

    if (obligations && Array.isArray(obligations)) {
      obligations.forEach(obligation => {
        if (obligation.companyCode === slGroupItem.value && obligation.countryTaxTypeDescription === countryTaxType.label && obligation.enabledFlag === 'N') {
          isEnabled = false;
        }
      });
    }

    const directEntries = findDirectTaxEntriesDeltaFroGrouppedReport(
      rows,
      {
        slGroupItem,
        periodFrom,
        countryTaxType,
        currencyToDisplay,
        bookType,
      }
    );

    submitDirectTaxEntries(
      directEntries,
      { callback: this.fetchReportData },
      isEnabled
    );
  };

  render() {
    const {
      slGroupType,
      slGroupItem,
      countryTaxType,
      bookType,
      reportData,
      currencyToDisplay,
      bookTypes,
      changeBookType,
      isFetchingReportData,
      isExportingReport,
      updateEditedCellForGroup,
      revertEditedCellsForGroup,
      isAllowedToMakeDirectEntries,
      pendingSubmissionsCount,
      isRowShadingEnabled,
      tbeErrorVal,
    } = this.props;

    const label = countryTaxType && slGroupItem
      ? `Country Tax Type: ${countryTaxType.value}, ${slGroupType.label}: ${slGroupItem.label}, Currency: ${currencyToDisplay}`
      : '';

    return (
      <div className="view-tax-reserves-page">
        <NavigationPrompt
          show={pendingSubmissionsCount > 0}
          title={PENDING_ENTRIES_TITLE}
          message={PENDING_ENTRIES_MESSAGE}
        />
        <SecondaryMenu>
          <AggregationMenu
            exportToExcel={this.exportToExcel}
            exportToCsv={this.exportToCsv}
            isExportingReport={isExportingReport}
            includeFbosCTT
          />
        </SecondaryMenu>
        <div className="page">
          <div className="container-fluid page-content-container">
            <div className="row no-gutters">
              <div className="col">
                {(!countryTaxType || !bookTypes.length || !slGroupItem)
                  ? null
                  : <IsClientLocked
                    render={isClientLocked => ( // eslint-disable-line react/jsx-no-bind
                      <GridReport
                        isRowShadingEnabled={isRowShadingEnabled}
                        bookType={bookType}
                        bookTypes={bookTypes}
                        countryTaxType={countryTaxType}
                        selectBookType={changeBookType}
                        chosenValuesText={label}
                        tbeErrorWarning={tbeErrorVal.tbeError}
                        columnDefinitions={getColumnDefinitions(
                          reportData,
                          isAllowedToMakeDirectEntries,
                          isClientLocked
                        )}
                        reportData={reportData && reportData.rows}
                        reportTitle="Tax Reserve"
                        isFetchingReportData={isFetchingReportData}
                        onCellValueChanged={updateEditedCellForGroup}
                        elementToRenderNextToPills={(
                          <PendingSubmissions
                            entriesCount={pendingSubmissionsCount}
                            revertEditedCells={revertEditedCellsForGroup}
                            submitEditedCells={this.submitDirectEntries}
                          />
                        )}
                      />
                    )}
                  />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    periodFrom: selectPeriodFrom(state),
    periodTo: selectPeriodTo(state),
    slGroupType: selectSlGroupType(state),
    slGroupItem: selectSlGroupItem(state),
    tbeErrors: tbeErrorsSelector(state),
    countryTaxType: selectCountryTaxType(state),
    bookType: selectBookType(state),
    bookTypes: selectBookTypes(state),
    reportData: selectReportData(state),
    tbeErrorVal: tbeErrorObjSelector(state),
    pendingSubmissionsCount: pendingSubmissionsCountSelector(state),
    currencyToDisplay: currencyToDisplaySelector(state),
    reportingCurrency: reportingCurrencyCodeSelector(state),
    isFetchingReportData: selectIsFetchingTaxReservesReport(state),
    isLoadingTbeErrors: isLoadingTbeErrorsSelector(state),
    isExportingReport: isExportingTaxReserveReportSelector(state),
    shouldDisplayZero: displayZeroSelector(state),
    hideDecimals: hideDecimalsSelector(state),
    negativeMinus: negativeMinusSelector(state),
    isAllowedToMakeDirectEntries: isAllowedToMakeDirectEntriesSelector(state),
    environmentSuffix: environmentSuffixSelector(state),
    isRowShadingEnabled: shadeGridFlagSelector(state),
    obligations: obligationsSelector(state),
    period: periodOrCurrentSelector(state),
  };
}

export default connect(
  mapStateToProps,
  {
    changeBookType,
    fetchReportData: fetchReportDataForViewTaxReservePage,
    exportToExcel,
    exportToCsv,
    updateEditedCellForGroup,
    revertEditedCellsForGroup,
    submitDirectTaxEntries,
    fetchAccounts,
  }
)(ViewTaxReservesPage);
